<template>
  <div class="home">
    <module-card :hdata="itemData"></module-card>

    <el-row :gutter="10">
      <el-col :span="12" class="mar-b-sm">
        <div class="bg-white" style="width: 100%; height: 300px">
          <div class="text-sm text-title pad-l-xs">下位点位情况</div>
          <el-col :span="12">
            <div style="height: 260px; padding-top: 20px; margin-left: -30px">
              <echarts-one
                :hdata="itemData.IpcStation"
                title="工控下位接入点位"
              ></echarts-one>
            </div>
          </el-col>
          <el-col :span="12">
            <div style="height: 260px; padding-top: 20px; margin-left: -30px">
              <echarts-one
                :hdata="itemData.DciStation"
                title="嵌入式下位接入点位"
              ></echarts-one>
            </div>
          </el-col>
        </div>
      </el-col>

      <el-col :span="12" class="mar-b-sm">
        <div class="bg-white" style="width: 100%; height: 300px">
          <el-col :span="12">
            <div class="text-sm text-title pad-l-xs">
              报警问题处理情况
              <i
                class="fas fa-list pull-right text-title pad-r-md cur-pointer"
                title="点击详情"
                @click="onIpcProDetail"
              ></i>
            </div>
            <div style="height: 260px; padding-top: 20px">
              <echarts-two
                :hdata="itemData.IpcAlarm"
                title="工控报警问题"
              ></echarts-two>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="text-sm text-title pad-l-xs">
              <i
                class="fas fa-list pull-right text-title pad-r-md cur-pointer"
                title="点击详情"
                @click="onDciProDetail"
              ></i>
            </div>
            <div style="height: 260px; padding-top: 20px">
              <echarts-two
                :hdata="itemData.DciAlarm"
                title="嵌入式报警问题"
              ></echarts-two>
            </div>
          </el-col>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="10">
        <div class="bg-white" style="width: 100%; height: 300px">
          <div class="text-sm text-title pad-l-xs">
            嵌入式-点位信息-三日更新次数排行榜
          </div>
          <div style="height: 280px; margin-top: -10px">
            <echarts-update
              :hdata="itemData.UpdateTimesData"
              title=""
            ></echarts-update>
          </div>
          <!-- <el-table
            class="mar-t-lg"
            :data="itemData.UpdateTimesData"
            v-loading="loading"
            size="medium"
          >
            <el-table-column prop="SN" label="产品SN" align="center" width="170">
              <template slot-scope="{ row }">
                <el-tag>
                  {{ row.SN }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="StationName" label="点位名称" align="center" />
            <el-table-column prop="Times" label="更新次数" align="center" width="100" />
          </el-table> -->
          <!-- <el-col :span="12">
            <div class="text-sm text-title pad-l-xs">环境质量文档
              <i class="fas fa-list pull-right text-title pad-r-md cur-pointer"
                title="点击详情" @click="onIpcDetail"></i>
            </div>
            <el-table class="mar-t-lg" :data="itemData.IpcFiles" v-loading="loading" size="medium">
              <el-table-column prop="Name" label="文件名"/>
              <el-table-column prop="CreatedAt" label="上传时间">
                <template slot-scope="scope">
                  <span v-if="scope.row.CreatedAt">
                    {{scope.row.CreatedAt.substring(0, 10)}}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="12">
            <div class="text-sm text-title pad-l-xs">污染源文档
              <i class="fas fa-list pull-right text-title pad-r-md cur-pointer"
                title="点击详情" @click="onDciDetail"></i>
            </div>
            <el-table class="mar-t-lg" :data="itemData.DciFiles" v-loading="loading" size="medium">
              <el-table-column prop="Name" label="文件名"/>
              <el-table-column prop="CreatedAt" label="上传时间">
                <template slot-scope="scope">
                  <span v-if="scope.row.CreatedAt">
                    {{scope.row.CreatedAt.substring(0, 10)}}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-col> -->
        </div>
      </el-col>

      <el-col :span="14">
        <div class="bg-white" style="width: 100%; height: 300px">
          <div class="text-sm text-title pad-l-xs">
            嵌入式-产品出厂情况
          </div>
          <div style="height: 280px; margin-top: -10px">
            <echarts-dciout
              :hdata="itemData.DciOutData"
              title=""
            ></echarts-dciout>
          </div>
        </div>
        <!-- <div class="bg-white" style="width: 100%; height: 300px">
          <div class="text-sm text-title pad-l-xs">服务器接入情况</div>
          <el-col :span="8">
            <div class="text-muted mar-t-xl">服务器总连接数</div>
            <div class="text-num mar-t-xxl clearfix chartBox">
              <div class="text-num-one" v-for="(val, i) in textNumArr" :key="i">
                {{ val }}
              </div>
            </div>
          </el-col>
          <el-col :span="16">
            <el-col :span="8">
              <div style="height: 250px; padding-top: 20px">
                <echarts-three
                  :hdata="
                    itemData.Platformserver &&
                    itemData.Platformserver.Serviceplatformservercount
                  "
                  :color="color1"
                  title="业务平台服务器"
                ></echarts-three>
              </div>
            </el-col>
            <el-col :span="8">
              <div style="height: 250px; padding-top: 20px">
                <echarts-three
                  :hdata="
                    itemData.Platformserver &&
                    itemData.Platformserver.Databaseservercount
                  "
                  :color="color2"
                  title="数据库服务器"
                ></echarts-three>
              </div>
            </el-col>
            <el-col :span="8">
              <div style="height: 250px; padding-top: 20px">
                <echarts-three
                  :hdata="
                    itemData.Platformserver &&
                    itemData.Platformserver.Communicationservercount
                  "
                  :color="color3"
                  title="通讯服务器"
                ></echarts-three>
              </div>
            </el-col>
          </el-col>
        </div> -->
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ModuleCard from "./index--module-card.vue";
import EchartsOne from "./index--echarts-one.vue";
import EchartsTwo from "./index--echarts-two.vue";
import EchartsThree from "./index--echarts-three.vue";
// import EchartsFour from './index--echarts-four.vue';
import EchartsUpdate from "./index--echarts-update.vue";
import EchartsDciout from "./index--echarts-dciout.vue";

export default {
  components: {
    ModuleCard,
    EchartsOne,
    EchartsTwo,
    EchartsThree,
    // EchartsFour,
    EchartsUpdate,
    EchartsDciout,
  },
  data() {
    return {
      loading: false,
      itemData: {}, // 首页数据
      textNumNew: 0,
      color1: ["#38ADF2", "#E6F6FD"],
      color2: ["#FD933D", "#F7F4EF"],
      color3: ["#12BC83", "#E9F6F2"],
    };
  },
  computed: {
    textNumArr() {
      let arr = String(this.textNumNew.toFixed(0)).split("");
      if (arr.length > 6) {
        arr = [9, 9, 9, 9, 9, 9];
      } else if (arr.length < 6) {
        const len = 6 - arr.length;
        for (let i = 0; i < len; i++) {
          arr.unshift("0");
        }
      }
      return arr;
    },
  },
  mounted() {
    this.getItemData();
  },
  methods: {
    // 获取首页数据
    getItemData() {
      this.loading = true;
      this.$axios
        .get("homepage")
        .then((response) => {
          this.itemData = response.data;
          // 总连接数
          this.textNumNew =
            this.itemData.Platformserver &&
            this.itemData.Platformserver.Serviceplatformservercount
              ? this.itemData.Platformserver.Platformserverscount
              : 0;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onIpcDetail() {
      this.$router.push({ name: "MsDocument" });
    },
    onDciDetail() {
      this.$router.push({ name: "DsFile" });
    },
    // 环境质量问题
    onIpcProDetail() {
      // this.$router.push({ name: "IpcAlarmInform" });
      this.$router.push({ name: "PnAlarmInform" }); //改成报警管理
    },
    // 污染源问题
    onDciProDetail() {
      // this.$router.push({ name: "DciAlarmInform" });
      this.$router.push({ name: "AppAlarmIndex" }); //改成报警管理
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~variables";
.bg-black {
  background: mix($--color-black, $--color-white, 75%);
  .card-samll {
    background: mix($--color-black, $--color-white, 70%);
  }
  table {
    width: 100%;
    padding: 20px;
    thead {
      line-height: 30px;
      tr {
        background: mix($--color-black, $--color-white, 65%);
      }
    }
    tbody {
      tr {
        line-height: 35px;
        background: mix($--color-black, $--color-white, 70%);
        td {
          padding-left: 10px;
        }
      }
    }
  }
}
.text-num {
  padding-left: 30px;
  left: 25px;
  top: 55px;
  .text-num-one {
    float: left;
    width: 25px;
    height: 50px;
    background-color: #eaf7ff;
    margin-left: 2px;
    font-family: LED;
    font-size: 40px;
    color: #39aef1;
    text-align: center;
    line-height: 50px;
  }
}
.text-placeholder {
  color: $--color-text-placeholder;
}
.text-title {
  height: 20px;
  line-height: 40px;
  font-weight: 800;
}
</style>
